import { put, takeLatest, call } from 'redux-saga/effects';
import {
  GET_EXERCISES,
  CREATE_EXERCISE,
  UPDATE_EXERCISE,
  DELETE_EXERCISE,
  RESTORE_EXERCISE,
  GET_ARCHIVED_EXERCISES,
  SAVE_EXERCISE_HISTORY,
  GET_EXERCISE_HISTORY_BY_IDS,
  GET_EXERCISES_HISTORY_BY_IDS_ARR,
  GET_EXERCISE_CATEGORIES,
  GET_MUSCLES,
  GET_RECENT_PRS,
} from './constants';
import {
  getExercises as getExercisesAction,
  getExercisesSuccess,
  getExercisesError,
  createExerciseSuccess,
  createExerciseError,
  updateExerciseSuccess,
  updateExerciseError,
  deleteExerciseSuccess,
  deleteExerciseError,
  restoreExerciseSuccess,
  restoreExerciseError,
  getArchivedExercisesSuccess,
  getArchivedExercisesError,
  saveExerciseHistorySuccess,
  saveExerciseHistoryError,
  getExerciseHistoryByIdsSuccess,
  getExerciseHistoryByIdsError,
  getExercisesHistoryByIdsArrSuccess,
  getExercisesHistoryByIdsArrError,
  getAllExerciseHistoryByIdsSuccess,
  getAllExerciseHistoryByIdsError,
  getExerciseCategoriesSuccess,
  getExerciseCategoriesError,
  getMusclesSuccess,
  getMusclesError,
  getRecentPrsSuccess,
  getRecentPrsError,
} from './actions';
import { fetchData } from '../api';
import { toast } from '../../components/Toast';

export function* getExercises() {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/exercise`;
    const token = window.localStorage.token;
    const config = {
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
    };

    let exercises = yield call(fetchData, url, config);
    yield put(getExercisesSuccess(exercises));
  } catch (err) {
    console.log(err);
    const error = yield err.json();
    console.log(error);
    yield put(getExercisesError(error));
  }
}

export function* createExercise({ exercise }) {
  const token = localStorage.token;
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/exercise`;
    const config = {
      method: 'POST',
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(exercise),
    };

    const createdExercise = yield call(fetchData, url, config);
    yield put(createExerciseSuccess(createdExercise));
  } catch (err) {
    console.log(err);
    const error = yield err.json();
    console.log(error);
    yield put(createExerciseError(error));
  }
}

export function* updateExercise({ exercise }) {
  const token = localStorage.token;
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/exercise/${exercise._id}`;
    const config = {
      method: 'POST',
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(exercise),
    };

    const createdExercise = yield call(fetchData, url, config);
    yield put(updateExerciseSuccess(createdExercise));
  } catch (err) {
    console.log(err);
    const error = yield err.json();
    console.log(error);
    yield put(updateExerciseError(error));
  }
}

export function* deleteExercise({ id }) {
  const token = localStorage.token;
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/exercise/${id}`;
    const config = {
      method: 'DELETE',
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
    };
    const data = yield call(fetchData, url, config);
    // API returns { success, action: 'archived' | 'deleted', msg }.
    // 'archived' = the exercise was in use, so it's hidden (soft-deleted)
    // and existing logs are preserved; 'deleted' = truly removed.
    if (data && data.action === 'archived') {
      toast.info(
        data.msg ||
          "Hidden from your library — it's in use, so existing logs are kept.",
        { position: 'top-right', duration: 5000 }
      );
    } else {
      toast.success('Exercise deleted.', {
        position: 'top-right',
        duration: 5000,
      });
    }
    yield put(deleteExerciseSuccess(id));
  } catch (err) {
    const error = yield err.json();
    toast.error(error.error || 'Failed to delete exercise', {
      position: 'top-right',
      duration: 5000,
    });
    yield put(deleteExerciseError(error));
  }
}

export function* restoreExercise({ id }) {
  const token = localStorage.token;
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/exercise/${id}/restore`;
    const config = {
      method: 'PATCH',
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
    };
    yield call(fetchData, url, config);
    toast.success('Exercise restored.', {
      position: 'top-right',
      duration: 5000,
    });
    yield put(restoreExerciseSuccess(id));
    // Pull the freshened active list so the restored exercise reappears
    // in the main library.
    yield put(getExercisesAction());
  } catch (err) {
    const error = yield err.json();
    toast.error(error.error || 'Failed to restore exercise', {
      position: 'top-right',
      duration: 5000,
    });
    yield put(restoreExerciseError(error));
  }
}

export function* getArchivedExercises() {
  const token = localStorage.token;
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/exercise?archivedOnly=true`;
    const config = {
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
    };
    const archived = yield call(fetchData, url, config);
    yield put(getArchivedExercisesSuccess(archived));
  } catch (err) {
    const error = yield err.json();
    yield put(getArchivedExercisesError(error));
  }
}

export function* saveExerciseHistory({ dataArr, workoutId }) {
  const token = localStorage.token;
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/exercise-history?workoutId=${workoutId}`;
    const config = {
      method: 'POST',
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(dataArr),
    };
    const exerciseHistoriesArr = yield call(fetchData, url, config);
    yield put(saveExerciseHistorySuccess(exerciseHistoriesArr));
  } catch (err) {
    console.log(err);
    const error = yield err.json();
    console.log(error);
    yield put(saveExerciseHistoryError(error));
  }
}

export function* getExerciseHistoryByIds({
  clientId,
  exerciseId,
  allHistory,
  callback,
}) {
  const token = localStorage.token;
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/exercise-history/${clientId}/${exerciseId}?allHistory=${allHistory}`;
    const config = {
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
    };
    const exerciseHistory = yield call(fetchData, url, config);
    if (allHistory) {
      yield put(getAllExerciseHistoryByIdsSuccess(exerciseHistory, exerciseId));
    } else {
      yield put(
        getExerciseHistoryByIdsSuccess({
          ...exerciseHistory,
          exerciseId,
        })
      );
    }
    if (callback) {
      if (Object.keys(exerciseHistory).length !== 0) {
        callback(exerciseHistory);
      } else {
        callback({});
      }
    }
  } catch (err) {
    console.log(err);
    const error = yield err.json();
    console.log(error);
    if (allHistory) {
      yield put(getExerciseHistoryByIdsError(error));
    } else {
      yield put(getAllExerciseHistoryByIdsError(error));
    }
    if (callback) {
      callback({}); // Call the callback with an empty object when there is no history
    }
  }
}

//Get exercise history by user id and array of exercise ids or 'all' for all exercises
export function* getExercisesHistoryByIdsArr({ clientId, exerciseIdsArr }) {
  const token = localStorage.token;
  try {
    const url = `${
      process.env.REACT_APP_API_URL
    }/api/exercise-history/${clientId}?exerciseIds=${
      exerciseIdsArr === 'all' ? 'all' : exerciseIdsArr.join(',')
    }`;

    const config = {
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
    };
    const exercisesHistory = yield call(fetchData, url, config);

    yield put(getExercisesHistoryByIdsArrSuccess(exercisesHistory));
  } catch (err) {
    console.log(err);
    const error = yield err.json();
    console.log(error);
    yield put(getExercisesHistoryByIdsArrError(error));
  }
}

export function* getExerciseCategories() {
  const token = localStorage.token;
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/exercise-category/all`;

    const config = {
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
    };
    const exerciseCategories = yield call(fetchData, url, config);

    yield put(getExerciseCategoriesSuccess(exerciseCategories));
  } catch (err) {
    console.log(err);
    const error = yield err.json();
    console.log(error);
    yield put(getExerciseCategoriesError(error));
  }
}

export function* getMuscles() {
  const token = localStorage.token;
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/muscle/all`;

    const config = {
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
    };
    const muscles = yield call(fetchData, url, config);

    yield put(getMusclesSuccess(muscles));
  } catch (err) {
    console.log(err);
    const error = yield err.json();
    console.log(error);
    yield put(getMusclesError(error));
  }
}

export function* getRecentPrs({ clientId, limit }) {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/exercise-history/user/${clientId}/recent-prs?limit=${limit || 8}`;
    const config = {
      headers: {
        'x-auth-token': window.localStorage.token,
        'Content-Type': 'application/json',
      },
    };
    const prs = yield call(fetchData, url, config);
    yield put(getRecentPrsSuccess(prs));
  } catch (err) {
    let error = err;
    try {
      error = yield err.json();
    } catch (_) {
      // err wasn't a Response — fall through with the original.
    }
    console.log('getRecentPrs failed:', error);
    yield put(getRecentPrsError(error));
  }
}

export default function* exercisesSaga() {
  yield takeLatest(GET_EXERCISES, getExercises);
  yield takeLatest(CREATE_EXERCISE, createExercise);
  yield takeLatest(UPDATE_EXERCISE, updateExercise);
  yield takeLatest(DELETE_EXERCISE, deleteExercise);
  yield takeLatest(RESTORE_EXERCISE, restoreExercise);
  yield takeLatest(GET_ARCHIVED_EXERCISES, getArchivedExercises);
  yield takeLatest(SAVE_EXERCISE_HISTORY, saveExerciseHistory);
  yield takeLatest(GET_EXERCISE_HISTORY_BY_IDS, getExerciseHistoryByIds);
  yield takeLatest(
    GET_EXERCISES_HISTORY_BY_IDS_ARR,
    getExercisesHistoryByIdsArr
  );
  yield takeLatest(GET_EXERCISE_CATEGORIES, getExerciseCategories);
  yield takeLatest(GET_MUSCLES, getMuscles);
  yield takeLatest(GET_RECENT_PRS, getRecentPrs);
}
